import { NgModule } from "@angular/core";

import { ModalService } from "./modal.service";

@NgModule({
	providers: [ModalService],
	imports: [],
})
export class ModalModule {}
